import React, { useState } from 'react';
import axios from 'axios';
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import CONFIG from '../../config';
import { useAuth } from '../../context/AuthProvider';
import { usePatient } from '../../context/PatientContext';
import styles from '../../Styles/navbar.module.css';  

const CheckForm = () => {
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const baseURL = CONFIG.BASE_URL;
  const { doctorInfo, setDoctorInfo, token, setToken } = usePatient();

  const initialValues = {
    mobileNumber: '',
    password: ''
  };

  const validationSchema = Yup.object().shape({
    mobileNumber: Yup.string()
      .required('Mobile number is required')
      .matches(/^(\+\d{1,3}[- ]?)?\d{10}$/, 'Invalid mobile number'),
    password: Yup.string().required('Password is required')
  });

  const handleSubmit = async (values, actions) => {
    try {
      const { data } = await axios.post(`${baseURL}/mandali/check`, values);

      if (data.token) {
        localStorage.setItem('authToken', data.token); // ✅ Store token
        setToken(data.token);
        console.log('data post login:', data);
        setAuth(data.userData); // ✅ Update global auth state
        //        setDoctorInfo({ MANDALI_ID: auth.MANDALI_ID, CLINIC_ID: auth.CLINIC_ID }); // ✅ Store doctor info globally
        // setDoctorInfo({
        //   MANDALI_ID: data.userData.MANDALI_ID,
        //   CLINIC_ID: data.userData.CLINIC_ID,
        //   MANDALI_ROLE: data.userData.MANDALI_ROLE
        // });
        setDoctorInfo({
          MANDALI_ID: data.userData.MANDALI_ID,
          MANDALI_ROLE: data.userData.MANDALI_ROLE,
          CLINIC_ID: data.userData.CLINIC_LIST[0]?.CLINIC_ID || null,
          CLINIC_LIST: data.userData.CLINIC_LIST || []
        });

        console.log('doctor info:', doctorInfo);

        navigate('/patientlist'); // ✅ Navigate to patient list after login
        console.log('authentication success');

      } else {
        alert('Login failed! Check credentials.');
      }
    } catch (error) {
      alert('Login error: ' + (error.response?.data?.message || error.message));
    }
    actions.setSubmitting(false);
  };




  return (
<div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <h2 className={styles.heading}>Login</h2>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ errors, touched }) => (
            <Form>
              <div className={styles.formGroup}>
                <label htmlFor="mobileNumber">Mobile Number</label>
                <Field name="mobileNumber" type="text"
                  className={`${styles.inputField} ${touched.mobileNumber && errors.mobileNumber ? styles.invalid : ''}`}
                />
                <ErrorMessage name="mobileNumber" component="div" className={styles.error} />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="password">Password</label>
                <Field name="password" type="password"
                  className={`${styles.inputField} ${touched.password && errors.password ? styles.invalid : ''}`}
                />
                <ErrorMessage name="password" component="div" className={styles.error} />
              </div>

              <Button type="submit" className={styles.loginButton}>Login</Button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CheckForm;
